import React, { useState } from "react";
import {
  CardElement,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import styled from "styled-components";
import axiosServices from "../utils/axios";
import { useTranslation } from "react-i18next";
import toast from "react-hot-toast";

const CARD_OPTIONS = {
  iconStyle: "solid",
  style: {
    base: {
      iconColor: "#c4f0ff",
      color: "#000000",
      fontWeight: 500,
      fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: "16px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": { color: "#b3b3b3" },
      "::placeholder": { color: "#b3b3b3" },
    },
    invalid: {
      iconColor: "#ffc7ee",
      color: "#000000",
    },
  },
};

const CardInputWrapper = styled.div`
  border: 2px solid #f2f2f2;
  border-radius: 8px;
  padding: 10px 4px;
  color: #00f;
`;
function PaymentForm({
  user,
  varToken,
  basicDetails,
  stripePriceID,
  currentPackagesDetails,
}) {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [updatedInvoiceUrl, setUpdatedInvoiceUrl] = useState("");
  const [success, setSuccess] = useState(false);
  const [isCheckedPopup, setIsCheckedPopup] = useState(false);
  const stripeHooks = useStripe();
  const elements = useElements();
  const { t } = useTranslation();
  const stripe = require("stripe")(user?.apiSecretKey);
  console.log(basicDetails, "basicDetails");
  const updateStripeCustomer = async (paymentMethod) => {
    var customer;
    if (user?.stripCustomerId) {
      customer = await stripe.customers.retrieve(user.stripCustomerId);
      await stripe.paymentMethods.attach(paymentMethod?.id, {
        customer: customer.id,
      });

      await stripe.customers.update(customer.id, {
        invoice_settings: {
          default_payment_method: paymentMethod?.id,
        },
        metadata: {
          ownerId: user?.id,
          ownerType: user?.userRole,
        },
      });
    } else {
      // CREATE CUSTOMER
      customer = await stripe.customers.create({
        email: user?.emailAddress,
        name: `${user?.firstName} ${user?.lastName}`,
        phone: user?.phoneNumber,
        address: {
          line1: basicDetails?.addressLine1,
          line2: basicDetails?.addressLine2,
          city: basicDetails?.city,
          state: basicDetails?.state,
          country: basicDetails?.country,
          postal_code: basicDetails?.postalCode,
        },
        payment_method: paymentMethod?.id,
        invoice_settings: {
          default_payment_method: paymentMethod?.id,
        },
        metadata: {
          ownerId: user?.id,
          ownerType: user?.userRole,
        },
      });
    }

    axiosServices.put(
      `/api/customers/update-stripe/${user.id}`,
      {
        stripCustomerId: customer.id,
      },
      {
        headers: {
          Authorization: `Bearer ${varToken}`,
        },
      }
    );

    return customer;
  };

  console.log(user, "user");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      const cardNumberElement = elements.getElement(CardNumberElement);
      const { error, paymentMethod } = await stripeHooks.createPaymentMethod({
        type: "card",
        card: cardNumberElement,
        billing_details: {
          name: `${user?.firstName} ${user?.lastName}`,
          email: user?.emailAddress,
          phone: user?.phoneNumber,
          address: {
            line1: basicDetails?.addressLine1,
            line2: basicDetails?.addressLine2,
            city: basicDetails?.city,
            state: basicDetails?.state,
            country: basicDetails?.country,
            postal_code: basicDetails?.postalCode,
          },
        },
        metadata: {
          ownerId: user?.id,
          ownerType: user?.userRole,
        },
      });

      if (error) {
        toast.error(error?.message || "Create Payment method error!");
        console.log(error, "error from create payment method");
        setSuccess(false);
      }

      const customer = await updateStripeCustomer(paymentMethod);

      const subsData = {
        customer: customer.id,
        items: [{ price: stripePriceID }],
        metadata: {
          ownerId: user?.id,
          ownerType: user?.userRole,
        },
        payment_settings: {
          payment_method_options: {
            card: {
              request_three_d_secure: "automatic",
            },
          },
          // trial_period_days: priceId?.freeTrialDays ? Number(priceId?.freeTrialDays) : 0,
          payment_method_types: ["card"],
          save_default_payment_method: "on_subscription",
        },
        expand: ["latest_invoice.payment_intent"],
      };
      if (!error) {
        const scheduleData = {
          customer: customer.id,
          end_behavior: "release",
          // phases: [
          //   {
          //     items: [
          //       {
          //         price: stripePriceID,
          //         quantity: 1,
          //       },
          //     ],
          //     iterations: 12,
          //     proration_behavior: "none",
          //   },
          // ],
        };

        if (currentPackagesDetails?.stripeDepositeId) {
          scheduleData.phases = [
            {
              add_invoice_items: [
                {
                  price: currentPackagesDetails?.stripeDepositeId,
                  quantity: 1,
                },
              ],
              items: [
                {
                  price: stripePriceID,
                  quantity: 1,
                },
              ],
              iterations: 12,
              proration_behavior: "none",
            },
          ];
        } else {
          scheduleData.phases = [
            {
              items: [
                {
                  price: stripePriceID,
                  quantity: 1,
                },
              ],
              iterations: 12,
              proration_behavior: "none",
            },
          ];
        }

        // Check condition for is Scheduling or subscription
        if (user?.subscriptionScheduleDate) {
          const date = new Date(user?.subscriptionScheduleDate);
          const unixTimestamp = Math.floor(date.getTime() / 1000);
          scheduleData.start_date = unixTimestamp;

          const subscription = await stripe.subscriptionSchedules.create(
            scheduleData
          );
          const { status } = subscription;
          console.log(subscription, "subscription");
          console.log(status, "status");

          if (status === "not_started") {
            setSuccess(true);
          }
          if (status === "active") {
            setSuccess(true);
          }
        }
      }

      // if (coupon) {
      //   subsData.coupon = coupon;
      // }
      // const subscription = await stripe.subscriptions.create(subsData);

      // const { status } = subscription;

      // if (status === "incomplete") {
      //   const { hosted_invoice_url } = subscription.latest_invoice;

      //   window.open(hosted_invoice_url, "_blank");
      // }
      // if (status === "active") {
      //   const updatedInvoice = await stripe.invoices.update(
      //     subscription?.latest_invoice?.id,
      //     {
      //       metadata: {
      //         ownerId: user?.id,
      //         ownerType: user?.userRole,
      //       },
      //     }
      //   );
      //   if (updatedInvoice?.hosted_invoice_url) {
      //     setUpdatedInvoiceUrl(updatedInvoice?.hosted_invoice_url);
      //     setSuccess(true);
      //     toast.success("Payment Successfull!");
      //   }
      // }
    } catch (error) {
      console.log(error, "error from payment");
      window.alert(error?.message || "Something went wrong!");
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleOpenBrowserSetting = () => {
    window.open("https://support.google.com/chrome/answer/95472", "_blank");
  };

  return (
    <>
      {!success ? (
        <>
          <div className="pb-2 text-xl font-bold">
            {t("Please Fill Card Details.")}
          </div>
          <form onSubmit={handleSubmit}>
            <div>
              <div className="mb-2">
                <p variant="p">{t("Enter Your Card Number:")}</p>
                <CardInputWrapper>
                  <CardNumberElement options={CARD_OPTIONS} />
                </CardInputWrapper>
              </div>
              <div className="md:grid md:grid-cols-2 gap-6">
                <div className="mb-2">
                  <p variant="p">{t("Card Expiry Date:")}</p>
                  <CardInputWrapper>
                    <CardExpiryElement
                      options={CARD_OPTIONS}
                      style={{ border: "1px solid black" }}
                    />
                  </CardInputWrapper>
                </div>
                <div className="mb-2">
                  <p variant="p">{t("Enter CVC Number:")}</p>
                  <CardInputWrapper>
                    <CardCvcElement options={CARD_OPTIONS} />
                  </CardInputWrapper>
                </div>
              </div>
              <div className="mb-3 flex items-center gap-1 min-h-[1.5rem]">
                <input
                  className="w-4 h-4"
                  // className="relative float-left -ml-[1.5rem] mr-[6px] mt-[0.15rem] h-[1.125rem] w-[1.125rem] appearance-none rounded-[0.25rem] border-[0.125rem] border-solid border-neutral-300 outline-none before:pointer-events-none before:absolute before:h-[0.875rem] before:w-[0.875rem] before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-primary checked:bg-primary checked:before:opacity-[0.16] checked:after:absolute checked:after:-mt-px checked:after:ml-[0.25rem] checked:after:block checked:after:h-[0.8125rem] checked:after:w-[0.375rem] checked:after:rotate-45 checked:after:border-[0.125rem] checked:after:border-l-0 checked:after:border-t-0 checked:after:border-solid checked:after:border-white checked:after:bg-transparent checked:after:content-[''] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:shadow-none focus:transition-[border-color_0.2s] focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-[0px_0px_0px_13px_rgba(0,0,0,0.6)] focus:before:transition-[box-shadow_0.2s,transform_0.2s] focus:after:absolute focus:after:z-[1] focus:after:block focus:after:h-[0.875rem] focus:after:w-[0.875rem] focus:after:rounded-[0.125rem] focus:after:content-[''] checked:focus:before:scale-100 checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca] checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:after:-mt-px checked:focus:after:ml-[0.25rem] checked:focus:after:h-[0.8125rem] checked:focus:after:w-[0.375rem] checked:focus:after:rotate-45 checked:focus:after:rounded-none checked:focus:after:border-[0.125rem] checked:focus:after:border-l-0 checked:focus:after:border-t-0 checked:focus:after:border-solid checked:focus:after:border-white checked:focus:after:bg-transparent dark:border-neutral-600 dark:checked:border-primary dark:checked:bg-primary dark:focus:before:shadow-[0px_0px_0px_13px_rgba(255,255,255,0.4)] dark:checked:focus:before:shadow-[0px_0px_0px_13px_#3b71ca]"
                  type="checkbox"
                  checked={isCheckedPopup}
                  onChange={(e) => {
                    setIsCheckedPopup(e.target.checked);
                  }}
                  id="checkboxDefault"
                />
                <label
                  className="pl-[0.15rem] hover:cursor-pointer flex gap-1"
                  for="checkboxDefault"
                >
                  {t("Have you enabled browser pop-up?")}
                </label>
                <div
                  className="text-[#24949e] font-medium cursor-pointer"
                  onClick={handleOpenBrowserSetting}
                >
                  {t("check here")}
                </div>
              </div>
              {user?.packageId && user?.priceId && isCheckedPopup ? (
                <button
                  className="bg-[#24949e] mb-2"
                  style={{
                    width: "100%",
                    padding: "8px",
                    color: "#ffffff",
                    fontSize: "20px",
                    fontWeight: "600",
                    borderRadius: "10px",
                  }}
                  type="submit"
                >
                  {isSubmitting ? t("Paying...") : `${t("Pay")} `}
                </button>
              ) : (
                <button
                  disabled
                  className="bg-[#C1C1C1] mb-2"
                  style={{
                    width: "100%",
                    padding: "8px",
                    color: "#ffffff",
                    fontSize: "20px",
                    fontWeight: "600",
                    borderRadius: "10px",
                  }}
                  type="submit"
                >
                  {t("Pay")}
                </button>
              )}
            </div>
          </form>
        </>
      ) : (
        <div className="payment-success mb-2">
          <h2>{t("Payment successful")}</h2>
          <h3 className="Thank-you">{t("Thank you for your purchase!")}</h3>
          <div style={{ marginTop: 10 }}>
            {/* <button
              className="bg-[#24949e] mb-2"
              disabled
              style={{
                // width: "100%",
                padding: "8px",
                color: "#ffffff",
                // fontSize: "20px",
                display: "inline-block",
                // fontWeight: "600",
                borderRadius: "10px",
              }}
            >
              <a
                target="_blank"
                href={updatedInvoiceUrl}
                style={{ padding: 5, borderRadius: 5, marginTop: 5 }}
              >
                {t("Download Invoice")}
              </a>
            </button> */}
            {/* {user?.isSubscriptionSchedule && ( */}
            <div className="Thank-you">
              {t("Your Subscription created but Start At:")}{" "}
              {user?.subscriptionScheduleDate}
            </div>
            {/* )} */}
          </div>
        </div>
      )}
    </>
  );
}

export default PaymentForm;
